import React from 'react'
import PropTypes from 'prop-types'
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import IconEmbed from 'material-ui/svg-icons/action/settings-ethernet';
import './sideButtons.css';
import {colors} from '../../lib/styles';

import {AtomicBlockUtils, EditorState} from 'draft-js';
import {backendUrl} from '../../lib/config'

import vkEmbedScript from './vkEmbed';
import playbuzzEmbedScript from './playbuzzEmbed';

function getEmbedProvider(path) {
    const embedPath = {
        youtube: `http://www.youtube.com/oembed?url=${encodeURIComponent(path)}`,
        twitter: `https://publish.twitter.com/oembed?url=${encodeURIComponent(path)}`,
        instagram: `https://api.instagram.com/oembed?url=${encodeURIComponent(path)}`
    };
    let resultPath = path;
    for (const key in embedPath) {
        if (embedPath.hasOwnProperty(key) && path.search(`${key}.com`) !== -1) {
            resultPath = embedPath[key];
        }
    }
    return resultPath;
}

/**
 * Конвертация данных для вставки кода
 * @param {String} str данные, что нужны для embed
 * @return {String}
 */
function setEmbedData(str) {
    let data = null;
    if (str.search('vk_post_') !== -1) {
        data = {
            html: vkEmbedScript(str),
            provider_name: 'Vk',
        };
    }
    if (str.search('iframe') !== -1) {
        data = {
            html: str,
            provider_name: 'iframe'
        };
    }
    if (str.search('instagram-media') !== -1) {
        data = {
            html: str,
            provider_name: 'Instagram'
        };
    }
    if ((str.search('pb_feed') !== -1) || (str.search('playbuzz') !== -1)) {
        data = {
            html: playbuzzEmbedScript(str),
            provider_name: 'playbuzz'
        };
    }
    return data;
}

export default class EmbedSideButton extends React.Component {

    static propTypes = {
        setEditorState: PropTypes.func,
        getEditorState: PropTypes.func,
        close: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
        this.addEmbedURL = this.addEmbedURL.bind(this);
        this.state = {
            open: false,
            input: false,
            title: '',
            url: ''
        };
    }

    handleClose = () => {
        const component = this;
        component.setState({
            open: false
        });
        setTimeout(function() {
            component.props.close();
        }, 150);
    };

    onClick() {
        this.setState({
            open: true,
            input: true,
            title: 'Добавление элемента'
        });
    }

    setEmbedCode = () => {
        const url = this.state.url;
        if (!url) {
            return;
        }
        this.setState({
            input: false,
            open: false
        });
        const reg = /twitter.com|instagram.com|youtube.com|vk_post_|iframe|instagram-media|pb_feed|playbuzz/gi;
        const result = url.match(reg);
        if (!result) {
            const _t = this;
            setTimeout(function() {
                _t.setState({
                    input: false,
                    open: true,
                    title: 'Нельзя встроить публикацию из этого ресурса.',
                    url: ''
                });
            }, 500);

            return;
        }
        this.addEmbedURL(url);
    };

    setEditor(data) {
        let editorState = this.props.getEditorState();
        const content = editorState.getCurrentContent();
        const contentWithEntity = content.createEntity('embed', 'IMMUTABLE', data);
        const entityKey = contentWithEntity.getLastCreatedEntityKey();
        editorState = EditorState.push(editorState, contentWithEntity, 'create-entity');
        this.props.setEditorState(AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, 'E'));
    }

    addEmbedURL(url) {
        const data = setEmbedData(url);

        if (data) {
            this.setEditor(data);
            this.handleClose();
        } else {
            const formData = new FormData();
            formData.append('url', getEmbedProvider(url));
            fetch(`${backendUrl}/embed`, {
                method: 'POST',
                body: formData
            })
                .then(res => {
                    return res.json();
                })
                .then(data => {
                    this.setEditor(data);
                    this.handleClose();
                });
        }
    }

    onSetUrl = e => {
        this.setState({ url: e.target.value })
    };

    render() {
        const actions = [<FlatButton
            label="Ok"
            primary={true}
            onClick={(this.state.url ? this.setEmbedCode : this.handleClose)}
        />];
        let dialogInner = '';
        if (this.state.input) {
            dialogInner = <TextField
                floatingLabelText="Элемент для встраивания"
                value={this.state.url}
                fullWidth={true}
                onChange={this.onSetUrl}
                multiLine={true}
                rows={1}
            />;
        }
        return (
            <button
                className="medium-draft--btn"
                type="button"
                title="Embed"
                onClick={this.onClick}
            >
                <Dialog
                    title={this.state.title}
                    actions={actions}
                    modal={true}
                    open={this.state.open}
                >
                    {dialogInner}
                </Dialog>
                <IconEmbed color={colors.iconColor} hoverColor={colors.iconHover}/>
            </button>
        );
    }
}



// WEBPACK FOOTER //
// src/components/editor/EmbedSideButton.js